import { Filter } from 'lucide-react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { DASHBOARD_COLORS as COLORS } from '../../constants/dashboard.constants';

export function ProductMixChart({ pieData }: { pieData: { name: string; value: number }[] }) {
  const PIE_COLORS = [COLORS.primary, COLORS.secondary, COLORS.accent, '#64748b'];

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden flex flex-col h-[380px]">
      <div className="px-5 py-4 border-b border-slate-100 bg-slate-50/50">
        <h3 className="font-semibold text-slate-800">Mix Produit (Séléction)</h3>
      </div>
      <div className="flex-1 p-6 pb-8 min-h-[280px]">
        {pieData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={pieData} cx="50%" cy="45%" innerRadius={60} outerRadius={95} paddingAngle={5} dataKey="value">
                {pieData.map((_entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={PIE_COLORS[index % PIE_COLORS.length]}
                    stroke="white"
                    strokeWidth={2}
                  />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: any) => [`${value} rés.`, 'Quantité']}
                contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                  padding: '8px 12px',
                }}
              />
              <Legend
                iconType="circle"
                wrapperStyle={{
                  fontSize: '13px',
                  paddingTop: '20px',
                  fontWeight: '500',
                }}
                iconSize={10}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex flex-col items-center justify-center text-slate-400 text-sm gap-2">
            <div className="p-3 bg-slate-50 rounded-full">
              <Filter className="w-5 h-5 text-slate-300" />
            </div>
            <p>Aucun type trouvé</p>
          </div>
        )}
      </div>
    </div>
  );
}
